import { appendOrCreateContact as publicAppendOrCreateContact } from './contacts-v4-submit-contact-submitted-contact.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const appendOrCreateContact: MaybeContext<
  BuildRESTFunction<typeof publicAppendOrCreateContact> &
    typeof publicAppendOrCreateContact
> = /*#__PURE__*/ createRESTModule(publicAppendOrCreateContact);

export {
  EmailTag,
  PhoneTag,
  AddressTag,
  SubdivisionType,
  ImageProvider,
  ContactActivityType,
  IdentityType,
  SubmitOperation,
  ContactSourceType,
  WebhookIdentityType,
} from './contacts-v4-submit-contact-submitted-contact.universal.js';
export {
  SubmitContact,
  SubmitContactRequest,
  ContactInfo,
  ContactName,
  ContactEmailsWrapper,
  ContactEmail,
  ContactPhonesWrapper,
  ContactPhone,
  ContactAddressesWrapper,
  ContactAddress,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  AssigneesWrapper,
  LabelsWrapper,
  ExtendedFieldsWrapper,
  LocationsWrapper,
  ContactPicture,
  ContactActivity,
  ActivityIcon,
  SubmitContactOptions,
  SubmitContactResponse,
  ContactToSubmit,
  SubmitVisitorIdRequest,
  SubmitVisitorIdResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  AppendOrCreateContactOptions,
} from './contacts-v4-submit-contact-submitted-contact.universal.js';
export {
  EmailTagWithLiterals,
  PhoneTagWithLiterals,
  AddressTagWithLiterals,
  SubdivisionTypeWithLiterals,
  ImageProviderWithLiterals,
  ContactActivityTypeWithLiterals,
  IdentityTypeWithLiterals,
  SubmitOperationWithLiterals,
  ContactSourceTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  AppendOrCreateContactApplicationErrors,
} from './contacts-v4-submit-contact-submitted-contact.universal.js';
